import { FormInstance } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import { ILoanClosingCost, ISettingItem } from '../hooks/users';
import { JsonResult } from './index';
import { OCCUPANCY_USE } from '../components/Pages/Reports/constants';

export interface IOption {
  value: number | string;
  label: string;
}

export interface IReportRow {
  id?: number;
  tabIndex?: number;
  order: number;
  active?: boolean;
  name: string;
  inputType?: 'text' | 'number';
  isExternalLoans?: boolean;
  subName?: string;
  text?: string;
  details?: (isBorrower?: boolean) => ReactNode;
  placeholder?: string;
  prefix?: string;
  suffix?: string;
  static?: boolean;
  disabled?: (loan: ILoanColumn) => boolean;
  hidden?: boolean;
  options?: () => IOption[];
  bolded?: boolean;
  color?: string | null;
  additionalText?: (loan: ILoanColumn, loans?: ILoanColumn[], reportType?: EnumReportTypes | undefined,
                    enableComparisonDisplay?: boolean, form?: FormInstance) =>
    { text: string; style?: CSSProperties } | undefined;
  informationText?: (loan: ILoanColumn, form?: FormInstance) => string;
  prepareData?: (
    loan: ILoanColumn,
    loans?: ILoanColumn[],
    form?: FormInstance,
    key?: number | string
  ) => number | string | undefined;
  extra?: JSX.Element;
  styles?: CSSProperties;
  subField?: IReportRow;
  note?: string;
  isHiddenForBorrower?: boolean;
  onChange?: (form: FormInstance,
    key: number | string,
    value: string,
    handleLoansUpdate?: (event?: unknown, withLoading?: boolean) => void,
    loan?: ILoanColumn,
    reportLoanClosingCosts?: ILoanClosingCost[],
    reportClosingCosts?: ISettingItem[],
  ) => void;
  onSelect?: (form: FormInstance, key: number | string, value: string) => void;
  getPopoverContent?: (
    field: JsonResult,
    rowsLength: number,
    form: FormInstance,
    handleLoansUpdate?: (event?: unknown, withLoading?: boolean) => void
  ) => ReactNode;
}

export type OccupancyUse = typeof OCCUPANCY_USE[keyof typeof OCCUPANCY_USE];

export interface ILoanColumn {
  [key: string]: {
    value?: number | string;
    focused?: boolean;
    loanToValue?: number;
    propertyValue?: number;
    floodInsurance?: number;
    rent?: number;
    occupancyUse?: OccupancyUse;
    mortgageInsuranceDeduction?: number;
    removeDownPayment?: boolean;
    existingLoanPayoff?: number; // TODO: This field is not used, we can remove it.
    loanType?: string;
    vaFundingFee?: number;
    vaFundingFeePercentage?: number;
    addVaFundingFee?: boolean;
    pmiPercentage?: number;
    addClosingCosts?: boolean;
    addCashOut?: boolean;
  };
}

export interface ILoanAdvancedValue {
  value?: number | string | null;
}

export interface ILoanValue {
  [key: string]: string | number | ILoanAdvancedValue | undefined | null;
}

export enum EnumReportTypes {
  purchase = 'purchase',
  refinance = 'refinance',
}
